<template>
  <div v-if="isClose" class="closeTxt">{{ gconfig.RegistStopWords }}</div>
  <template v-else>
    <!-- <step :active="0" v-show="(isWeX && openid) || !isWeX"></step> -->
     <!-- <div class="login" v-show="(isWeX && openid) || !isWeX">-->
      <div class="login" >
      <div class="enBox" v-if="gconfig.OverSeaLink">
        <a :style="{ color: gconfig.mainColor }" :href="gconfig.OverSeaLink"
          ><img :src="enImg" style="width: 28px" alt=""
        /></a>
      </div>
      <div
        class="exhName"
        v-if="gconfig.HomePageTitle"
        v-html="gconfig.HomePageTitle"
      ></div>
      <h3 class="exhName" v-else>{{ gconfig.ExhibitionName }}</h3>
      <div class="logins">
        <h2 class="loginTit">Register/Login</h2>
        <!-- 邮箱 -->
        <div class="loginFormbox">
          <van-form ref="loginFormG" @submit="onSubmitG">
            <div class="formItem">
              <van-field
                v-model="formG.Name"
                name="Name"
                label="Name"
                placeholder="Please enter a name that matches your identification document"
                :rules="[
                  {
                    required: true,
                    validator: validatorName,
                    message: 'Please enter a name that matches your identification document'
                  }
                ]"
              />
            </div>
            <div class="formItem">
              <van-field
                v-model="formG.Email"
                name="Email"
                label="Email"
                placeholder="Please enter correct email address"
                :rules="[
                  {
                    required: true,
                    validator: validatorEmail,
                    message: 'Please enter correct email address'
                  }
                ]"
              />
            </div>

            <div class="btnbox pad40">
              <van-button
                type="primary"
                :color="mainColor"
                native-type="submit"
              >
                Register/Login
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </template>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api/index.js'
import { showLoadingToast, showToast } from 'vant'
import { regEmail } from '@/utils/regs.js'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
import enImg from '@/assets/enImg.png'
sessionStorage.clear()
const store = useStore()
const router = useRouter()
const route = useRoute()
// 保存入口路径
sessionStorage.setItem('enterPath', route.path)
if (route.query.source) {
  sessionStorage.setItem('source', route.query.source)
}
// 邀请参数
if (route.query.invitesource) {
  sessionStorage.setItem('invitesource', route.query.invitesource)
}
if (route.query.invitesourceID) {
  sessionStorage.setItem('invitesourceID', route.query.invitesourceID)
}
if (route.query.lan) {
  sessionStorage.setItem('lan', route.query.lan)
}
if (route.query.ExhCode) {
  store.commit('setExhCode', route.query.ExhCode)
} else {
  showToast({
    message: 'Exhibition parameters are missing！',
    wordBreak: 'break-all',
    type: 'fail'
  })
}
const openid = computed(() => store.state.openid)
const isWeX = computed(() => store.state.isWeX)
const isPCWeX = computed(() => store.state.isPCWeX)
const ExhCode = computed(() => {
  return store.state.ExhCode
})
const mainColor = computed(() => store.state.mainColor)
const formG = ref({
  code: '',
  Email: ''
})
// 校验邮箱
const validatorEmail = (val) => {
  return regEmail.test(val)
}
// 校验验证码格式
const regCode = /^[0-9]{4}$/
const validatorCode = (val) => {
  return regCode.test(val)
}
onMounted(() => {
  showLoadingToast({
    duration: 0,
    message: 'Loading...',
    forbidClick: true
  })
  getToken()
})
const token = computed(() => {
  return store.state.token
})
const getToken = async () => {
  const res = await api.getTokenApi()
  store.commit('setToken', res.data.authorToken)
  getOpenID()
  getGlobalConfig()
}
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalEValue
    })
  }
  return configObj
}
const getGlobalConfig = async () => {
  const res = await api.getGConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const tmpObj = {}
    const resObj = JSON.parse(decryptionECB(res.data.configuartion))

    resObj.forEach((item) => {
      tmpObj[item.GlobalKey] = item.GlobalEValue
    })
    store.commit('setGConfig', res.data.configuartion)
    store.commit('setMainColor', tmpObj.ButtonColor)
    // 判断展会是否关闭
     closeRes(gconfig.value.RegistStopTime)
   // closeRes('2025-02-04 14:00:00')

    if (isWeX.value&& !isPCWeX.value) {
      wx.getWXSign()
    }

  }
}
const isClose = ref(false)
const closeRes = (str) => {
  const val = str.replace(/-/g, '/')
  isClose.value = new Date().getTime() >= new Date(val).getTime()
}
const timer = ref(null)
const downTime = (time) => {
  timer.value = setInterval(() => {
    if (time > 0) {
      time--
      btnTxt.value = `${time}s`
    } else {
      btnTxt.value = 'Send Verification Code'
      clearInterval(timer.value)
    }
  }, 1000)
}
const btnTxt = ref('Send Verification Code')
const loginFormG = ref()
const getEmailSms = () => {
  loginFormG.value.validate('Email').then((valid) => {
    if (!valid) {
      api
        .getEmailCodeApi({
          Email: formG.value.Email,
          token: token.value,
          ExhCode: ExhCode.value
        })
        .then((res) => {
          if (res.code === 200) {
            downTime(60)
            showToast({
              message:
                'The verification code has been successfully sent. Please check your inbox！',
              wordBreak: 'break-all',
              type: 'success'
            })
          }
        })
    }
  })
}
const getOpenID = () => {
  // 当前链接加获取时间
  const cUrl = window.location.href + '&time=' + Math.round(new Date() / 1000)

  if (isWeX.value && !isPCWeX.value) {
    if (cUrl.indexOf('openid') === -1) {
      if (cUrl.indexOf('InviteType') !== -1) {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}&InviteType=eg`
      } else {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}`
      }
    } else {
      // 如果有openid
      store.commit('setOpenID', route.query.openid)
      // 根据openid判断是否注册
      if (openid.value) {
        checkOpenid()
      } else {
        router.go(0)
      }
    }
  }
}
const checkOpenid = () => {
  api
    .checkIdentityLoginApi({
      openid: openid.value,
      ExhCode: ExhCode.value,
      aliID: ''
    })
    .then((res) => {
      if (res.code === 200) {
        if (res.data) {
          store.commit('setVisitorID', res.data.visitorID)
          sessionStorage.setItem('invitesource', '1')
          sessionStorage.setItem('invitesourceID', res.data.visitorID)
          if (gconfig.value.SuccessPageVersion === 'V2') {
            router.push({ path: '/successV2' })
          } else {
            router.push({ path: '/success' })
          }
        }
      }
    })
}

//  登录
const onSubmitG = () => {
  loginFormG.value.validate().then((valid) => {
    if (!valid) {
      showLoadingToast({
        message: 'loading...',
        forbidClick: true
      })
      api
        .checkEmailLoginApi({
          Email: formG.value.Email,
          Name:formG.value.Name,
          ExhCode: ExhCode.value,
          OpenID: openid.value
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              // 邮箱已注册
              if (res.data.visitorID) {
                store.commit('setVisitorID', res.data.visitorID)
                if (gconfig.value.SuccessPageVersion === 'V2') {
                  router.push({ path: '/successV2' })
                } else {
                  router.push({ path: '/success' })
                }
              }
            } else {
              store.commit('setLoginForm', formG.value)
              router.push({ path: '/msg' })
            }
          }
        })
    }
  })
}
</script>
<style lang="less">
@import '../../assets/login.less';
.closeTxt {
  padding-top: 100px;
}
.login {
  .enBox {
    text-align: right;
    padding: 0 3vw;
  }
  .tabs {
    border-bottom: 1px solid #fff;
    width: 90%;
    margin: 0 auto 6px;
    display: flex;
    span {
      display: inline-block;
      flex: 1;
      text-align: center;
      padding: 10px 0;
    }
    .active {
      background: rgba(255, 255, 255, 0.6);
      border-radius: 4px 4px 0 0;
      border-bottom: 2px solid #1989fa;
    }
  }
  .logins {
    padding: 30px 10px 0;
    width: 90%;
    border: 1px solid #eee;
    margin: 0 auto;
    border-radius: 6px;
    box-shadow: 0 0 10px #eaeaea;
    background: #fff;
    .loginTit {
      font-size: 5vw;
      padding-bottom: 2vw;
    }
  }
  .loginFormbox {
    .van-button--plain.van-button--primary {
      height: 40px;
      border: 0;
      border-left: 1px solid #666 !important;
      border-radius: 0;
    }
  }
  .exhName {
    padding: 0 12px 30px;
    line-height: 30px;
  }
  .btnbox {
    padding: 60px 18px 0px;
    .van-button {
      width: 100%;
    }
  }
  .pad40 {
    padding-bottom: 40px;
  }
}
@media screen and (min-width: 768px) {
  .login {
    .logins {
      .loginTit {
        font-size: 18px;
      }
    }
  }
}
</style>
